import { owaDate } from 'owa-datetime';
import { InsertLinkSource } from 'owa-editor-ribbonplugin';
import insertLink, {
    getLinkNodeInsideSelection,
    INSERT_LINK_SHORTCUT,
    showInsertLinkDialog,
} from 'owa-editor-ribbonplugin/lib/components/buttons/insertLink';
import { createLink } from 'owa-editor-ribbonplugin/lib/components/buttons/insertLink.locstring.json';
import {
    RibbonButton,
    RibbonDropDownProps,
} from 'owa-editor-ribbonplugin/lib/components/buttons/RibbonButton';
import cacheEditorSelection from 'owa-editor-ribbonplugin/lib/utils/cacheEditorSelection';
import loc from 'owa-localize';
import * as React from 'react';
import { InsertLinkFromFilePickerContext } from '../types/InsertLinkFromFilePickerContext';
import { HyperlinkContextMenu } from './HyperlinkContextMenu';

export function getInsertLinkWithFilePicker(
    filePickerContext: InsertLinkFromFilePickerContext
): RibbonButton {
    return {
        ...insertLink,
        onExecute: undefined,
        createDropDownCallback: React.memo(
            ({ editorViewState, target, dismiss }: RibbonDropDownProps) => {
                const { range } = cacheEditorSelection(editorViewState);
                const linkNode: HTMLAnchorElement | null = getLinkNodeInsideSelection(
                    editorViewState,
                    range
                );
                const targetWindow = target.ownerDocument!.defaultView!;

                if (!!linkNode) {
                    showInsertLinkDialog(
                        editorViewState,
                        targetWindow,
                        InsertLinkSource.FlightedRibbon,
                        owaDate(),
                        dismiss
                    );
                    return null;
                }

                return (
                    <HyperlinkContextMenu
                        menuTargetElement={target}
                        onDismissMenu={dismiss}
                        insertLinkTitle={loc(createLink)}
                        insertLinkShortcut={INSERT_LINK_SHORTCUT}
                        filePickerContext={filePickerContext}
                        targetWindow={targetWindow}
                        editorViewState={editorViewState}
                        showInsertLinkDialog={showInsertLinkDialog}
                    />
                );
            }
        ),
    };
}
